var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigureLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25441 4.80223H8.68204L1.77809 1.84959L3.25441 4.80223ZM3.25441 5.84433L1.77809 8.81867L8.68204 5.84433H3.25441ZM1.32217 0.525251L11.0485 4.69367C11.309 4.80223 11.4827 5.06275 11.4827 5.34499C11.4827 5.60551 11.309 5.86604 11.0485 5.97459L1.32217 10.143C1.06165 10.2516 0.735988 10.1864 0.540594 9.96933C0.345199 9.77394 0.301778 9.44828 0.432041 9.18775L2.36428 5.32328L0.432041 1.48051C0.301778 1.21999 0.345199 0.89433 0.540594 0.677225C0.735988 0.48183 1.06165 0.416698 1.32217 0.525251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigureLogo);
export default __webpack_public_path__ + "static/media/configure-logo.9c22f4151f7bc2cf2678e214364505e7.svg";
export { ForwardRef as ReactComponent };